import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default from 'react';
import MaterialDialog from '@mui/material/Dialog';
import RefForwardedTransition from '../Transition/index.js';
import { DEFAULT_BACKDROP_PROPS, DEFAULT_TRANSITION_PROPS, DEFAULT_TRANSITION_DURATION } from './consts.js';

var _excluded = ["TransitionProps"];
var Dialog = function Dialog(props) {
  var TransitionProps = props.TransitionProps,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React__default.createElement(MaterialDialog, _extends({
    BackdropProps: DEFAULT_BACKDROP_PROPS,
    TransitionComponent: RefForwardedTransition,
    TransitionProps: _extends({}, DEFAULT_TRANSITION_PROPS, TransitionProps),
    transitionDuration: DEFAULT_TRANSITION_DURATION
  }, restProps));
};

export { Dialog as default };
//# sourceMappingURL=Dialog.js.map
